import { Dialog, Portal } from "react-native-paper";
import { Button } from "~/components/Button";
import { AlertModal } from "~/components/feedback/AlertModal";
import { LoadingMask } from "~/components/feedback/LoadingMask";
import { Only } from "~/components/permission/Only";
import { useTheme } from "~/providers/ThemeProvider";

export type FeedbackPortalProps = {
    saving: boolean;
    loading: boolean;
    error: string | null;
    setError: (error: string | null) => void;
};

export const FeedbackPortal = ({ saving, loading, error, setError }: FeedbackPortalProps) => {
    const { colours } = useTheme();
    return (
        <Portal>
            {saving && <AlertModal loading title="Saving" description="This will just take a moment." name="saving" />}
            {error && (
                <AlertModal
                    title="Error"
                    description={error as string}
                    icon="warning-outline"
                    iconColour={colours.icon.danger}
                    dismissable
                    dismissableBackButton
                    onDismiss={() => setError(null)}
                    name="error"
                >
                    <Dialog.Actions>
                        <Button onPress={() => setError(null)} title="Dismiss" />
                    </Dialog.Actions>
                </AlertModal>
            )}
            <Only when={loading}>
                <LoadingMask />
            </Only>
        </Portal>
    );
};
